import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { ChevronRight } from "lucide-react";
import UserFormModal from "@/components/UserFormModal";
import HierarchyTree from "@/components/HierarchyNode";

export default function HierarchyPage() {
  const [tree, setTree] = useState(null);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({ open: false, roleId: null });

  const load = async () => {
    setLoading(true);
    try {
      const [h, r] = await Promise.all([api.get("/hierarchy"), api.get("/roles")]);
      setTree(h.data.root);
      setRoles(r.data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
  }, []);

  return (
    <div className="min-h-full">
      <div className="border-b border-[#262626] px-10 py-6 flex items-center justify-between bg-[#050505]/80 backdrop-blur-xl sticky top-0 z-30">
        <div>
          <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#d4af37]">Organization</p>
          <h1 className="font-display text-3xl text-white mt-1">Hierarchy Builder</h1>
        </div>
        <div className="text-xs text-gray-500 font-mono flex items-center gap-4">
          <span className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#d4af37]" />
            Director
          </span>
          <ChevronRight className="w-3 h-3" />
          <span className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-white" />
            Managers
          </span>
          <ChevronRight className="w-3 h-3" />
          <span className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-gray-500" />
            Executives
          </span>
        </div>
      </div>

      <div className="px-10 py-10 overflow-x-auto">
        {loading ? (
          <div className="text-center text-gray-500 py-20">Loading hierarchy…</div>
        ) : !tree ? (
          <div className="text-center text-gray-500 py-20">No hierarchy configured.</div>
        ) : (
          <div className="min-w-max flex justify-center pb-12">
            <HierarchyTree tree={tree} onAdd={(role) => setModal({ open: true, roleId: role.id })} />
          </div>
        )}
      </div>

      <UserFormModal
        open={modal.open}
        mode="add"
        user={null}
        roles={roles}
        presetRoleId={modal.roleId}
        onClose={() => setModal({ open: false, roleId: null })}
        onSaved={() => {
          setModal({ open: false, roleId: null });
          load();
        }}
      />
    </div>
  );
}
